var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store-Header"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"main-bg"},[(_vm.logoTop)?_c('img',{attrs:{"src":_vm.logoTop,"alt":""}}):_c('img',{attrs:{"src":require("../../../assets/images/storeBg.png"),"alt":""}}),_c('div',{staticClass:"main-fullname"},[_c('span',{staticClass:"main-span"},[_vm._v(_vm._s(_vm.shopName))])])]),_c('div',{staticClass:"main-search"},[_c('ul',[_c('li',{class:{ active: this.activeName === 'homePage' }},[_c('router-link',{attrs:{"rel":"opener","to":{
              path: '/homePage',
              query: {
                shopId: this.shopId,
                tenantId: this.tenantId,
                shopName: this.shopName
              }
            }}},[_c('i',[_vm._v("店铺首页")])])],1),_c('li',{class:{ active: this.activeName === 'storeGoods' }},[_c('router-link',{attrs:{"rel":"opener","to":{
              path: '/storeGoods',
              query: {
                shopId: this.shopId,
                inputValue: '',
                tenantId: this.tenantId,
                shopName: this.shopName,
                logoTop: this.logoTop
              }
            }}},[_c('i',[_vm._v("全部商品")])])],1),_c('li',[_c('Input',{staticStyle:{"width":"360px"},attrs:{"search":"","enter-button":"搜索本店","placeholder":"请输入配件编码/配件名称"},on:{"on-search":_vm.search},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}})],1)])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }